import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useCountUp } from "@/hooks/useCountUp";
import { useVocCharCount } from "@/hooks/useVocCharCount";

interface VocCharCountProps {
  workspaceId: string | null;
  start: Date | null;
  end: Date | null;
}

export const VocCharCount: React.FC<VocCharCountProps> = ({ workspaceId, start, end }) => {
  const { t } = useTranslation("admin");
  const { charCount } = useVocCharCount(workspaceId, start, end);
  const animatedCharCount = useCountUp(charCount ?? null);

  return (
    <div className="flex flex-col gap-0.5">
      <Text size="xs" c="dimmed">{t("analysis.charCount.label")}</Text>
      <Text size="xs" fw={500} className="tabular-nums">
        {animatedCharCount === null
          ? "-"
          : t("analysis.charCount.value", { charCountValue: animatedCharCount.toLocaleString() })}
      </Text>
    </div>
  );
};
